export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8813.b5954012.jpg";